import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class BankcityService {
  getEventRoute = "/api/bank/";
  constructor(private dataService: DataService) { }

  getcityById(id, refresh) {

  }
  getState(refresh: boolean) {
    return this.dataService.getData('/api/lookup/state', refresh);
  }

  getBank(id: number, refresh: boolean) {
    return this.dataService.getData('/api/bank/banklist/' + id, refresh)
  }

  getCity(stateid: number, bankid: number, refresh: boolean) {
    return this.dataService.getData('/api/city/citylist/' + stateid + '/' + bankid, refresh)
  }

  getIfscDetails(ifsc: string) {
    return this.dataService.getData('/api/bank/ifscdetails/' + encodeURIComponent(ifsc), true);
  }

  getbanklist(refresh: boolean) {
    return this.dataService.getData('/api/bank/bankgridlist', refresh);
  }

  gridDetails(bankid: number, stateid: number, cityid: number, refresh: boolean) {
    return this.dataService.getData('/api/branch/branchList/' + bankid + '/' + stateid + '/' + cityid, refresh)
  }

  saveBranch(data: any) {
    return this.dataService.post('/api/branch', data)
  }

  getBranchDetails(id:number,refresh:boolean)
  {
    return this.dataService.getData('/api/branch/'+id,refresh)
  }

  getCityByState(stateId: number, refresh: boolean) {
    return this.dataService.getData('/api/city/citylist/' + stateId, refresh);
  }
  getCityList(stateId, refresh) {
    return this.dataService.getData('/api/city/citylist/' + stateId, refresh);
  }
  getCityById(id, refresh) {
    return this.dataService.getData('/api/city/' + id, refresh);
  }

  bankSave(result: any) {
    return this.dataService.post('/api/bank/banksave', result).map(response => {
      this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }
  citySave(result: any) {
    return this.dataService.post('/api/city', result).map(response => {
      this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }

  deleteBranch(id:number,refresh:boolean)
  {
    return this.dataService.getData('/api/branch/DeleteById/'+id,refresh)
  }

  deleteCity(id:number,refresh:boolean)
  {
    return this.dataService.getData('/api/city/DeleteById/'+id,refresh)
    
  }

 
  deleteBank(id:number,refresh:boolean)
  {
    return this.dataService.getData('/api/bank/DeleteById/'+id,refresh)
    
  }

}
